import React from "react";

export default function AdminDashboard() {
  <></>;
}
